angular
  .module('app')
  .controller('ProfileController', ProfileController);

ProfileController.$inject = ['Users', 'Session', 'Countries'];

function ProfileController(Users, Session, Countries) {
  var vm = this;
  vm.successfull = false;
  vm.user = Users.get({id: Session.id});

  var countries = Countries.query().$promise;
  countries.then(function (res) {
    vm.countries = res;
  });

  vm.submit = function () {
    Users.save({id: Session.id, user: vm.user}, function () {
      Session.top();
      vm.successfull = true;
    });
  };
}
